// extracted by mini-css-extract-plugin
export default {"advantages":"styles_advantages__VbGaq","firstBlock":"styles_firstBlock__7R1B1","secondBlock":"styles_secondBlock__6CzKp"};